import dynamic from "next/dynamic";

import React from "react";

import { twMerge } from "tailwind-merge";

import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import TopNavBarMobile from "components/TopNavBar/TopNavBarMobile";
import useMediaQuery from "hooks/useMediaQuery";

import styles from "./styles.module.scss";

const Modal = dynamic(() => import("react-modal"), { ssr: false });

const ConfirmModal = ({
  children,
  onClose,
  title,
  onConfirm,
  confirmButtonText,
  confirmButtonClassName,
  cancelButtonClassName,
  bottomContent,
  className,
  overlayClassName,
  portalClassName,
}: {
  title: React.ReactNode;
  children?: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  confirmButtonText?: string;
  confirmButtonClassName?: string;
  cancelButtonClassName?: string;
  bottomContent?: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  portalClassName?: string;
}) => {
  const { mobile } = useMediaQuery();

  return (
    <Modal
      portalClassName={twMerge(styles.modal, portalClassName)}
      overlayClassName={twMerge(styles.overlay, overlayClassName)}
      className={twMerge(
        styles.content,
        mobile ? styles.mobileLayout : styles.desktopLayout,
        className
      )}
      isOpen
      onRequestClose={onClose}
      onAfterOpen={() => {
        document.body.style.overflowY = "hidden";
      }}
      onAfterClose={() => {
        document.body.style.overflowY = "";
      }}
    >
      <div className="flex flex-col md:justify-between h-full">
        <div>
          {mobile ? (
            <TopNavBarMobile
              customBackButtonLabel="Cancel"
              onGoBack={onClose}
            />
          ) : (
            <div className={styles.actionsBar}>
              <FontAwesomeIcon
                icon={faTimes}
                className={styles.closeButton}
                onClick={onClose}
              />
            </div>
          )}
          <h4 className="text-[22px] font-normal">{title}</h4>
        </div>
        {children}
        <div className={twMerge("overflow-auto", "mt-[10px]")}>
          <div className="flex justify-between w-full">
            <div>
              <button
                className={twMerge(
                  "min-w-[6em] px-[15px] py-[8px]",
                  "rounded-full border border-solid border-active-black bg-white hover:bg-active-black hover:text-white",
                  cancelButtonClassName
                )}
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
            <div className="text-right">
              <button
                className={twMerge(
                  "min-w-[6em] px-[15px] py-[8px]",
                  "rounded-full border-0 bg-smart-teal hover:bg-smart-teal-500 text-white",
                  confirmButtonClassName
                )}
                onClick={onConfirm}
              >
                {confirmButtonText || "OK"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {bottomContent}
    </Modal>
  );
};

export default ConfirmModal;
